<div class="img-cirlce-wrapper"
    [ngClass]="{'bg-default': color === 'default', 'bg-confirm': color === 'confirm', 'bg-go-lobby': color === 'goLobby'}">
    <img *ngIf="img" class="img-fluid" [src]="URL_DOCUMENTS+img" alt="profile-img" title="profile-img">
    <p *ngIf="!img" class="m-0 p-0"
        [ngClass]="{'text-default': color === 'default', 'text-confirm': color === 'confirm', 'text-go-lobby': color === 'goLobby'}">
        {{ doctorName }}{{ doctorLastName }}
    </p>
</div>